import { IButton } from './IButton';

const HeroButton = (props: IButton) => {
  const { handleOnClick, children, width } = props;

  return (
    <button
      style={{ width: width || 'auto' }}
      className="!h-fit rounded-full bg-white px-[8px] py-[5px] text-[12px] font-semibold leading-[14px] text-primary transition-shadow ease-in hover:shadow-md sm:rounded-full sm:!leading-[18px] md:px-[16px] md:py-[9px] md:text-[14px] md:!leading-[20px] lg:px-[32px] lg:py-[15.5px] lg:!leading-[21.12px] max-sm:rounded-[25px]"
      onClick={handleOnClick}
    >
      {children}
    </button>
  );
};

export default HeroButton;
